import { apiHttpClient } from './http'

export async function getClientInfo(clientToken) {
  try {
    const res = await apiHttpClient.get(`/clients/${clientToken}`)
    return res.data
  } catch (err) {
    throw new Error(err.message)
  }
}
